/* eslint-disable */ import { composedOfComponent, memoEval } from '@salsita-ai/platform-project-sdk/domain';
import { attachAdminComponent } from '../admin-implementation.js';
export const adminComponents = [
    attachAdminComponent.withComponent(composedOfComponent, '$pricingItems', true).withEntity('Admin').attach(memoEval((self)=>self.$pricingItems.map((entity)=>entity.id), (...ids)=>({
            childEntityIds: ids
        }))),
    attachAdminComponent.withComponent(composedOfComponent, '$cabinets', true).withEntity('Admin').attach(memoEval((self)=>self.$cabinets.map((entity)=>entity.id), (...ids)=>({
            childEntityIds: ids
        }))),
    attachAdminComponent.withComponent(composedOfComponent, '$parts', true).withEntity('Admin').attach(memoEval((self)=>self.$parts.map((entity)=>entity.id), (...ids)=>({
            childEntityIds: ids
        }))),
    attachAdminComponent.withComponent(composedOfComponent, '$appliances', true).withEntity('Admin').attach(memoEval((self)=>self.$appliances.map((entity)=>entity.id), (...ids)=>({
            childEntityIds: ids
        }))),
    attachAdminComponent.withComponent(composedOfComponent, '$presets', true).withEntity('Admin').attach(memoEval((self)=>self.$presets.map((entity)=>entity.id), (...ids)=>({
            childEntityIds: ids
        }))),
    attachAdminComponent.withComponent(composedOfComponent, '$presetCategories', true).withEntity('Admin').attach(memoEval((self)=>self.$presetCategories.map((entity)=>entity.id), (...ids)=>({
            childEntityIds: ids
        }))),
    attachAdminComponent.withComponent(composedOfComponent, '$recipes', true).withEntity('Admin').attach(memoEval((self)=>self.$recipes.map((entity)=>entity.id), (...ids)=>({
            childEntityIds: ids
        })))
];

//# sourceMappingURL=admin.js.map